var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('v-progress-circular',{attrs:{"rotate":360,"width":4,"value":_vm.campingScore.toFixed(),"color":_vm.getColor()}},[_vm._v(" "+_vm._s(_vm.campingScore.toFixed())+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }